(() => {
  if (window.holy1010NutritionReady) return;
  window.holy1010NutritionReady = true;
  document.addEventListener('click', event => {
    const open = event.target.closest('[data-holy-nutrition-open]');
    if (open) {
      const dialog = document.getElementById(open.dataset.holyNutritionOpen);
      if (dialog && !dialog.open) dialog.showModal();
      return;
    }
    const close = event.target.closest('[data-holy-nutrition-close]');
    if (close) close.closest('dialog')?.close();
    const dialog = event.target;
    if (dialog.matches?.('.holy-1010-nutrition-dialog') && dialog.open) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });
})();
